import { useTranslation } from "react-i18next";

import { IconReceiptCheck } from "@pentabd/icons";
import { Header } from "@pentabd/ui";
import { AnnualProcurementType } from "@type/procurements/annualProcurementPlan";

export const ProcurementDetailsPageHeader = ({
  data,
}: {
  data: AnnualProcurementType;
}) => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconReceiptCheck size="20" />,
    },
    {
      label: t("APP_DETAILS.BREADCRUMBS.FIRST_STEP"),
    },
  ];

  const headerText = {
    header: data ? data.title : "",
    subHeader: data ? data.financialYear : "",
  };

  return <Header breadcrumbs={breadcrumbs} headerText={headerText} />;
};
